import { Skeleton } from '@mui/material';

export const InformationBlockPlaceholderSkeleton = () => (
  <Skeleton variant="rounded" animation={false} width="100%" height={40} />
);
